module.exports = __webpack_public_path__ + "img/9788974254643.77917a82.jpg";